import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Santiago_Hernandez
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */
/**
 * Custom con funciones adicionales al formulario de produccion - Pesaje
 **/

class CustomPesajeProduccion  extends FormJaivana.form {
        
    constructor(props) {
        super(props);
        this.initForm                           = this.initForm.bind(this);
        this.successDatosFicha                  = this.successDatosFicha.bind(this);
        this.successPesoRecipiente              = this.successPesoRecipiente.bind(this);
        this.restarPesos                        = this.restarPesos.bind(this);
        this.grabarTodo                         = this.grabarTodo.bind(this);
        this.continuarFlujoProceso              = this.continuarFlujoProceso.bind(this);
        this.traerConceptoFicha                 = this.traerConceptoFicha.bind(this);
        this.successConceptoFicha               = this.successConceptoFicha.bind(this);
        this.articuloDensidad                   = 0;
        this.verFormula                         = this.verFormula.bind(this);
        this.successVerFormula                  = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula              = Object.assign({}, this.gridOptions);
        this.successClose                       = this.successClose.bind(this);
    }

    initForm(){
        console.log('Pesaje @Version: 1.01.0054, @Author: Juan David Nieto; @updateBy Sebastian Rios Echverri');
        this.traerConceptoFicha();
        this.getField('peso_balanza').setKeyUp(this.restarPesos);
        this.getField('btnAceptar').setClick(this.grabarTodo);

        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*
        this.generalFormat.nombre_accion = '280-Servicio_traer_datos_ficha'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successDatosFicha,
                error:this.error_,
                general: this.generalFormat
            });*/
            
        this.generalFormatPmv = { tipo_servicio: 'prod-pesaje', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successPesoRecipiente,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '280-Retorna_peso_recipiente'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successPesoRecipiente,
                error:this.error_,
                general: this.generalFormat
            });*/

        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    traerConceptoFicha(){
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha); 
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        // conceptoficha
        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'conceptoficha', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successConceptoFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '280-retorna_concepto_ficha'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successConceptoFicha,
                error:this.error_,
                general: this.generalFormat
            });  */   
    }

    successConceptoFicha(data){
        if(data.estado_p === 200){
            this.getField('concepto_ficha').setValue(data.data[0].descripcion);
        }
    }

    successDatosFicha(data){
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.getField('listaDatosFicha').setVisible(true);
            this.getField('listaDatosFicha').setItemsFichas(data.model);
        }else{
            this.getField('listaDatosFicha').setVisible(false);
        }
    }

    successPesoRecipiente(data){
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            let datamodel = data.model;
            this.getField('peso_recipiente').setValue(datamodel[0].peso_recipiente);
            this.articuloDensidad = data.model[0].densidad_formulacion
        }else{
            this.getField('peso_recipiente').setError(true,'* No se encontro ningún dato');
        }
    }

    restarPesos(){
        if(this.getField('peso_balanza').valid() && this.getField('peso_balanza').getValue() !== '' && this.articuloDensidad >= 1){
            let pesoKilos = parseFloat(this.getField('peso_balanza').getValue()) - parseFloat(this.getField('peso_recipiente').getValue());
            let pesoGalones = (pesoKilos/this.articuloDensidad);
            this.getField('galones_resultantes').setValue(pesoGalones.toFixed(2));
            this.getField('kilos_resultantes').setValue(pesoKilos.toFixed(2));
            this.getField('galones_resultantes').valid();
        }else{
            this.getField('galones_resultantes').setValue(0);
            this.getField('kilos_resultantes').setValue(0)
        }
    }

    grabarTodo(){
        if(this.getField('galones_resultantes').valid() & this.getField('peso_balanza').valid()){
            this.getField('galones_resultantes').setError(false,'');

            this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha); 
            this.getField('btnAceptar').setDisabled(true);

            let datos = {
                datos:{
                    produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                    galones_resultantes:this.getField('galones_resultantes').getValue(),
                    actividad_id:this.props.data.actividad_id
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-pesaje', operacion: 'aceptar', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.continuarFlujoProceso,
                error: this.error_,
                general: this.generalFormatPmv
            });

            /*this.generalFormat.nombre_accion = '280-Permite_agregar_el_peso'; 
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'POST',
                    body:body,
                    success:this.continuarFlujoProceso,
                    error:this.error_,
                    general: this.generalFormat
                });*/
        }else{
            if(this.getField('galones_resultantes').valid() && this.getField('galones_resultantes').getValue() === '' ){
                this.getField('galones_resultantes').setError(true,"Este campo es requerido");
            }
        }
    }
    continuarFlujoProceso(data){
        if(data.estado_p === 200){
            this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
            this.getField('proceso_id').setValue(this.props.data.proceso_id);
            this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
            this.getField('actividad_id').setValue(this.props.data.actividad_id);
            

            let datos = {
                datos:{
                    produccion_fichas_id: this.getField('produccion_fichas_id').getValue(),
                    proceso_id: this.getField('proceso_id').getValue(),
                    actividad_configuracion_id: this.getField('actividad_configuracion_id').getValue(),
                    actividad_id:this.getField('actividad_id').getValue() 
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-pesaje', operacion: 'envasar', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successClose,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '280-Permite_cotinuar_flujo-envasar'; 
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'POST',
                    body:body,
                    success:this.successCloseEstage,
                    error:this.error_,
                    general: this.generalFormat
                });  */              
        }else{
            this.getField('btnAceptar').setDisabled(false);
        }
        
    }

    successClose(data){
        this.getField('btnAceptar').setDisabled(false);
        this.successCloseEstage(data);
    }

}

export default CustomPesajeProduccion;
FormJaivana.addController("prod-pesaje",CustomPesajeProduccion);